import React from 'react';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Tooltip, Fade } from '@material-ui/core';


const styles = theme => ({
    root: {
        height: '100%',
        width: 240
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class EditCajaCentro extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            id: this.props.cajaCentro.id ? this.props.cajaCentro.id : uuidv4(),
            description: this.props.cajaCentro.descr ? this.props.cajaCentro.descr : '',
            iTipoZona: this.props.cajaCentro.iTipoZona ? this.props.cajaCentro.iTipoZona : this.props.tiposZona[0].id,
            tipoZona: this.props.cajaCentro.tipoZona ? this.props.cajaCentro.tipoZona : this.props.tiposZona[0].descr,
            canInput: this.props.cajaCentro.canInput ? true : false

        };


    };


    fillTiposZona = () => {

        return this.props.tiposZona.map(tz => {

            return (
                <option key={tz.id} value={tz.id}>{tz.descr}</option>
            );

        });

    };


    handleChange = event => {
        this.setState({ canInput: event.target.checked });
    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };

    handleTipoZonaChange = (event) => {

        const value = parseInt(event.target.value);

        this.setState({
            ...this.state,
            iTipoZona: value,
            tipoZona: this.props.tiposZona.find(tz => tz.id === value).descr
        });
    };

    render() {
        const { classes } = this.props;

        return (
            <form className={classes.root} autoComplete="off">

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'description'}
                            label={'Descripción'}
                            placeholder={'Descripción'}
                            margin="normal"
                            autoFocus
                            value={this.state.description}
                            onChange={(event) => this.handleValueChange(event, 'description')}
                        />
                    </FormControl>

                    <Tooltip title="Zona en la que se encuentra la caja" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="tipos-zona-placeholder">
                                Tipos de Zona
                            </InputLabel>
                            <Select
                                native
                                value={this.state.iTipoZona}
                                onChange={(event) => this.handleTipoZonaChange(event)}
                                name="tipoZona"
                            >
                                {this.fillTiposZona()}
                            </Select>
                        </FormControl>
                    </Tooltip>
                </div>
                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl} style={{ width: 210 }}>
                        <Tooltip title="Indica si debe incluirse en los datos de entrada del cierre diario" TransitionComponent={Fade} placement="right" TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.canInput}
                                        onChange={this.handleChange}
                                        value="canInput"
                                        color="primary"
                                    />
                                }
                                label="¿Puede recibir ingresos?"
                            />
                        </Tooltip>
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const caja = {
                            id: this.state.id,
                            descr: this.state.description,
                            iTipoZona: this.state.iTipoZona,
                            tipoZona: this.state.tipoZona,
                            canInput: this.state.canInput ? 1 : 0,
                            centroId: this.props.centroid
                        };

                        if (this.props.checkCaja(caja)) {

                            this.props.okHandler(caja);
                            this.props.hideDialog();
                        };
                    }
                    }>Guardar</Button>
                </div>
            </form>
        );

    };


};

EditCajaCentro.propTypes = {
    cajaCentro: PropTypes.object.isRequired,
    tiposZona: PropTypes.array.isRequired,
    okHandler: PropTypes.func.isRequired,
    checkCaja: PropTypes.func.isRequired,
    centroid: PropTypes.number.isRequired,
    hideDialog: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditCajaCentro);